import { paramsFromRecord } from '@common-lib';

export const routes = {
  auth: {
    login: '/login',
  },
  orders: (shopId: string | number | undefined, orderId?: string) =>
    `/${shopId}/orders${paramsFromRecord({ orderId })}`,
  orderHistory: (shopId: string | number | undefined, orderId?: string) =>
    `/${shopId}/order-history${paramsFromRecord({ orderId })}`,
  kitchenDisplay: (shopId: string | number | undefined, orderId?: string) =>
    `/${shopId}/kitchen-display${paramsFromRecord({ orderId })}`,
  stats: (shopId: string | number | undefined) => `/${shopId}/stats`,
  printerSettings: (shopId: string | number | undefined) =>
    `/${shopId}/printer-settings`,
  settings: (shopId: string | number | undefined) => `/${shopId}/settings`,
  siteConfiguration: (shopId: string | number | undefined) =>
    `/${shopId}/site-configuration`,
  notFound: '/not-found',
  unAuth: '/unauth',
};
